import { queryOptions } from '@tanstack/react-query';

import { dashboardApi } from '../api/dashboard.api';

import { Filters, Globals } from '@data-access';
import { pointsApi } from '@fields/data-access';

export const dashboardQueries = (global: Globals) => ({
  all: () => [global, 'dashboard'],
  samplingStats: () =>
    queryOptions({
      queryKey: [...dashboardQueries(global).all(), 'sampling-stats'],
      queryFn: () => pointsApi.getStats(),
    }),
  adminStats: (filters: Filters) =>
    queryOptions({
      queryKey: [...dashboardQueries(global).all(), 'admin', filters],
      queryFn: () => dashboardApi.getAdminStats(filters),
    }),
});
